import '@Global/modal';

import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import App from '@Components/app';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {ModalContainer} from '@Components/modal-container';
import type {AiChatProps} from '@/ai-chat/ai-chat';
import {AiChat} from '@/ai-chat/ai-chat';
import {renderApp} from '@Utils/renderApp.util';

const reactPageProps = window.reactPageProps as AiChatProps;

function AiChatApp(): ReactElement | null {
  const [i18Loaded, setI18Loaded] = useState(false);

  useEffect(() => {
    window.PMW.initI18next(window.PMW.LANGUAGE, () => {
      setI18Loaded(true);
    });
  }, []);

  if (!i18Loaded) {
    return <App />;
  }

  return (
    <App nonStrictModeChildren={<AiChat {...reactPageProps} />}>
      <ModalContainerDeprecated />
      <ModalContainer />
    </App>
  );
}

renderApp(<AiChatApp />, 'ai-chat-app');
